import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';

const state = {
    id: 0,
    nombre: '',
    retencionTipoId: 0,
    retencionTipo: null,
    retencionTipoNombre: null,
    inactivo: false,
    rowVersion: null,
    
    retencionRegimenDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_RETENCION_REGIMEN'(state, retencionRegimenId) {
        state.id = retencionRegimenId;
        state.nombre = '';
        state.retencionTipoId = 0;
        state.retencionTipo = null;
        state.retencionTipoNombre = null;
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_RETENCION_REGIMEN'(state, retencionRegimen) {
        state.nombre = retencionRegimen.nombre.trim();
        state.retencionTipoId = retencionRegimen.retencionTipo? retencionRegimen.retencionTipo.id : 0;
        state.retencionTipo = retencionRegimen.retencionTipo;
        state.retencionTipoNombre = retencionRegimen.retencionTipo? retencionRegimen.retencionTipo.nombre.trim() : null;
        state.inactivo = retencionRegimen.inactivo;
        state.rowVersion = retencionRegimen.rowVersion;
    },
    'SET_RETENCION_TIPO' (state, retencionTipo) {
        state.retencionTipoId = retencionTipo? retencionTipo.id : 0;
        state.retencionTipo = retencionTipo;
        state.retencionTipoNombre = retencionTipo? retencionTipo.nombre.trim() : null;
    },

    'INICIALIZAR_RETENCION_REGIMEN_DATOS' (state) {
        state.retencionRegimenDatos = [];
    },
    'SET_RETENCION_REGIMEN_DATOS' (state, params) {
        state.retencionRegimenDatos = params.retencionRegimenDatos;
    }
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, retencionRegimenId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RETENCION_REGIMEN', retencionRegimenId);

            if (retencionRegimenId != 0) {
                apiAxios.get('retencionesregimenes/' + retencionRegimenId + '/abm' ) 
                    .then(res => {
                        commit('SET_RETENCION_REGIMEN', res.data);
                        resolve();
                    })
                    .catch(error => reject(error) )
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let retencionRegimen = {
                nombre: state.nombre.toUpperCase().trim(), 
                retencionTipoId: state.retencionTipoId,
                retencionTipo: state.retencionTipo,
                inactivo: state.inactivo,
            }

            let url = 'retencionesregimenes';
            if (state.id != 0) {
                retencionRegimen.rowVersion = state.rowVersion;
                url += '/' + state.id;
            }

            apiAxios.post(url, retencionRegimen)
                .then(() => {
                    resolve();
                })
                .catch( error => {
                    var appError = false
                    var errorMessage = ''
                    if (error.response.status == 500) {
                        if (error.response.headers['application-error']) {
                            errorMessage = error.response.data
                        }
                    }
                    if (!appError) {
                        errorMessage = error.response.data
                    }          
                    reject(errorMessage)
                })
        })
    },
    setRetencionTipo: ({commit}, retencionTipo) => {
        commit('SET_RETENCION_TIPO', retencionTipo);
    },

    getRetencionRegimenDatos ( { commit }, retencionRegimenId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RETENCION_REGIMEN_DATOS');

            if (retencionRegimenId != 0) {
                apiAxios.get('retencionesregimenes/' + retencionRegimenId ) 
                .then(res => {
                    let retencionRegimenDatos = [
                        { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                        { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                        { 'nombre': 'retencionTipo', 'campo': 'Tipo de Retención', 'valor': res.data.retencionTipo, 'formato': '' },
                        { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': res.data.inactivo ? 'Si' : 'No', 'formato': '' },
                    ];
                    
                    let params = {
                        retencionRegimenDatos 
                    }
                    commit('SET_RETENCION_REGIMEN_DATOS', params);

                    resolve();
                })
                .catch(error => reject(error))
            } else {
                resolve();
            }
            
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}